<template>
  <!-- 轻量远程用户选择器：输入姓名/手机号 → 防抖去后端按关键字拉匹配用户 → 下拉选择。
       HeyUI 的 Select/AutoComplete 仅前端过滤且不 emit 搜索词，无法远程取数，故自定义。 -->
  <div class="user-picker" v-clickoutside="close">
    <input
      class="up-input"
      type="text"
      :value="displayValue"
      :placeholder="placeholder"
      @focus="onFocus"
      @blur="onBlur"
      @input="onInput($event.target.value)"
      @keydown.down.prevent="move(1)"
      @keydown.up.prevent="move(-1)"
      @keydown.enter.prevent="enter"
    />
    <i v-if="selectedLabel && !focusing" class="fa fa-check up-tick"></i>
    <div class="up-dropdown" v-show="open">
      <div class="up-loading" v-if="loading">搜索中…</div>
      <template v-else>
        <div
          v-for="(u, i) in results"
          :key="u.id"
          class="up-item"
          :class="{ active: i === hi }"
          @mousedown.prevent="pick(u)"
          @mouseenter="hi = i"
        >
          <span class="up-name">{{ u.realName }}</span>
          <span class="up-mobile">{{ u.mobile }}</span>
          <span class="up-org muted" v-if="u.defaultOrgName">{{ u.defaultOrgName }}<span v-if="u.orgCount > 1"> 等{{ u.orgCount }}个</span></span>
        </div>
        <div class="up-empty" v-if="!results.length">{{ searched ? '无匹配用户' : '输入姓名或手机号搜索' }}</div>
      </template>
    </div>
  </div>
</template>

<script>
import { userApi } from '../api';

export default {
	name: 'UserPicker',
	props: {
		value: { type: [Number, String], default: null },
		placeholder: { type: String, default: '输入姓名/手机号搜索' },
		pageSize: { type: Number, default: 20 }
	},
	data() {
		return {
			keyword: '',
			focusing: false,
			open: false,
			loading: false,
			searched: false,
			results: [],
			hi: -1,
			selectedLabel: '',
			timer: null
		};
	},
	computed: {
		displayValue() {
			if (this.focusing) return this.keyword;
			return this.selectedLabel;
		}
	},
	watch: {
		// 父层重置（如清空）时同步显示
		value(v) {
			if (!v) { this.selectedLabel = ''; this.keyword = ''; }
		}
	},
	directives: {
		clickoutside: {
			bind(el, binding) {
				el._upClick = (e) => { if (!el.contains(e.target)) binding.value(); };
				document.addEventListener('click', el._upClick);
			},
			unbind(el) { document.removeEventListener('click', el._upClick); }
		}
	},
	methods: {
		onFocus() {
			this.focusing = true;
			// 已选中时把当前值带入输入框，便于继续微调检索
			if (this.selectedLabel) this.keyword = this.selectedLabel;
			this.open = true;
		},
		onBlur() {
			// 延迟关闭，给 mousedown 选中留时间
			setTimeout(() => { this.focusing = false; this.open = false; }, 150);
		},
		onInput(val) {
			this.keyword = val;
			// 输入即放弃旧选择
			if (this.value) { this.$emit('input', null); this.$emit('change', null); }
			clearTimeout(this.timer);
			this.timer = setTimeout(() => this.search(), 250);
		},
		async search() {
			const kw = (this.keyword || '').trim();
			if (!kw) { this.results = []; this.searched = false; this.open = false; return; }
			this.loading = true; this.open = true; this.hi = -1;
			try {
				const r = await userApi.list({ keyword: kw, page: 1, pageSize: this.pageSize });
				this.results = r.list;
				this.searched = true;
			} catch (e) { this.results = []; }
			finally { this.loading = false; }
		},
		move(step) {
			if (!this.results.length) return;
			this.hi = (this.hi + step + this.results.length) % this.results.length;
		},
		enter() {
			if (this.hi >= 0 && this.results[this.hi]) this.pick(this.results[this.hi]);
		},
		pick(u) {
			this.$emit('input', u.id);
			this.$emit('change', u);
			this.selectedLabel = `${u.realName}（${u.mobile}）`;
			this.keyword = '';
			this.focusing = false;
			this.open = false;
		},
		close() { this.open = false; }
	}
};
</script>

<style lang="less" scoped>
.user-picker { position: relative; display: inline-block; width: 100%; }
.up-input {
	width: 100%; height: 32px; padding: 0 28px 0 10px;
	border: 1px solid #dcdfe6; border-radius: 4px; outline: none;
	&:focus { border-color: #3788ee; }
}
.up-tick { position: absolute; right: 10px; top: 50%; transform: translateY(-50%); color: #0acf97; font-size: 12px; }
.up-dropdown {
	position: absolute; top: calc(100% + 4px); left: 0; right: 0; z-index: 1000;
	background: #fff; border: 1px solid #e4e7ed; border-radius: 4px;
	box-shadow: 0 2px 12px rgba(0,0,0,.1); max-height: 280px; overflow-y: auto;
}
.up-loading, .up-empty { padding: 10px; text-align: center; color: #9aa4b2; font-size: 13px; }
.up-item { padding: 7px 10px; cursor: pointer; display: flex; align-items: center; gap: 10px; font-size: 13px;
	&:hover, &.active { background: #f0f7ff; }
}
.up-name { font-weight: 500; color: #1f2937; min-width: 56px; }
.up-mobile { color: #6b7280; }
.up-org { margin-left: auto; font-size: 12px; }
.muted { color: #9aa4b2; }
</style>
